module.exports = __webpack_public_path__ + "static/media/retooling.cfeed406.png";